export default __webpack_public_path__ + "static/largePhotoHero-ab2dfe7bd7ced33802d0b71e36934d9d.png";